import i18next from 'i18next';
import {
  AGREEMENT_TYPE,
  IAgreementTemplatetAggregatorForm,
} from 'services/templates/agreement-template/types';
import {
  IContractTemplateForm,
  IContractTemplateTreeItemForm,
  SIDE_MENU_TYPE,
  TEMPLATE_TYPE,
} from 'services/templates/types';
import { contractTemplateUtil } from 'utils';

export const agreementTemplateInitialItem: IAgreementTemplatetAggregatorForm = {
  type: AGREEMENT_TYPE.text,
  selectAgreementTemplate: {
    defaultValue: '',
    title: '',
    options: [],
  },
  textAgreementTemplate: {
    defaultValue: '',
    title: '',
  },
};

export const agreementTemplateInitialParagraphItem: IAgreementTemplatetAggregatorForm =
  {
    type: AGREEMENT_TYPE.paragraph,
    paragraphAgreementTemplate: {
      defaultValue: '',
      title: '',
    },
    textAgreementTemplate: null,
    selectAgreementTemplate: null,
  };

export const agreementTemplateInitialItems = (
  children?: IContractTemplateTreeItemForm
): IContractTemplateTreeItemForm[] => [
  {
    id: '0',
    type: TEMPLATE_TYPE.contract,
    content: i18next.t('contract-template.section.contract-title'),
    disabled: true,
    disabledMoreButton: true,
    disabledCollapse: true,
    disabledSelection: true,
    disabledRemove: true,
    children: [
      {
        id: '1',
        type: TEMPLATE_TYPE.section,
        content: 'Agreement template',
        children: children
          ? [children]
          : [
              {
                content: agreementTemplateInitialItem,
                id: '2',
                children: [],
                type: TEMPLATE_TYPE.agreement,
              },
            ],
        disabledMoreButton: true,
        disabledCollapse: true,
        disabledSelection: true,
        disabledRemove: true,
        disabled: true,
      },
    ],
  },
];

export const agreementTemplateInitialValues = (
  children?: IContractTemplateTreeItemForm
): IContractTemplateForm => ({
  ...contractTemplateUtil.form.initialValues,
  sideMenu: {
    type: SIDE_MENU_TYPE.agreementDetail,
    displayed: true,
    detail: {
      content:
        children?.type === TEMPLATE_TYPE.agreement
          ? children.content
          : agreementTemplateInitialItem,
      id: children?.id ?? '2',
    },
  },
  items: agreementTemplateInitialItems(children),
});

export const agreementTemplateInitialParagraphValues = (
  children?: IContractTemplateTreeItemForm
): IContractTemplateForm => {
  const paragraphChild: IContractTemplateTreeItemForm = children ?? {
    content: agreementTemplateInitialParagraphItem,
    id: '2',
    children: [],
    type: TEMPLATE_TYPE.agreement,
  };

  return {
    ...contractTemplateUtil.form.initialValues,
    sideMenu: {
      type: SIDE_MENU_TYPE.agreementDetail,
      displayed: true,
      detail: {
        content:
          paragraphChild.type === TEMPLATE_TYPE.agreement
            ? paragraphChild.content
            : agreementTemplateInitialParagraphItem,
        id: paragraphChild.id ?? '2',
      },
    },
    items: agreementTemplateInitialItems(paragraphChild),
  };
};
